import React, { useEffect, useState } from 'react';

const inputClass =
  'h-11 w-full rounded-xl border border-blanco-puro/20 bg-azul-oscuro/70 px-3 text-blanco-puro placeholder:text-blanco-puro/40 outline-none transition focus:border-amarillo-dorado focus:ring-2 focus:ring-amarillo-dorado/40';

export default function StockModal({
  abierto,
  producto,
  guardando,
  error,
  onClose,
  onReposicion,
  onAjuste,
}) {
  const [modo, setModo] = useState('reposicion');
  const [cantidad, setCantidad] = useState('');
  const [nuevoStock, setNuevoStock] = useState('');
  const [motivo, setMotivo] = useState('');

  useEffect(() => {
    if (!abierto) return;

    setModo('reposicion');
    setCantidad('');
    setNuevoStock('');
    setMotivo('');
  }, [abierto, producto]);

  if (!abierto || !producto) return null;

  const stockActual = Number(producto.stock_actual || 0);

  const submit = (event) => {
    event.preventDefault();

    if (modo === 'reposicion') {
      onReposicion({
        cantidad,
        motivo: motivo || null,
      });
      return;
    }

    onAjuste({
      stock_actual: nuevoStock,
      motivo: motivo || null,
    });
  };

  return (
    <div className="fixed inset-0 z-[110] grid place-items-center bg-black/70 p-4 backdrop-blur-sm">
      <form
        onSubmit={submit}
        className="w-full max-w-lg overflow-hidden rounded-2xl border border-blanco-puro/20 bg-gradient-to-br from-azul-oscuro to-azul-lago text-blanco-puro shadow-2xl"
      >
        <div className="border-b border-blanco-puro/15 px-6 py-5">
          <div className="text-xs font-bold uppercase tracking-[0.18em] text-amarillo-dorado">
            Driza Camp · Inventario
          </div>

          <h2 className="mt-1 text-2xl font-bold">
            Movimiento de stock
          </h2>

          <p className="mt-1 text-sm text-blanco-puro/70">
            {producto.nombre}
          </p>
        </div>

        <div className="p-6">
          <div className="mb-5 rounded-xl border border-blanco-puro/15 bg-blanco-puro/5 p-4">
            <div className="text-xs font-semibold uppercase tracking-wide text-blanco-puro/60">
              Stock actual
            </div>

            <div className="mt-1 text-3xl font-bold text-amarillo-dorado">
              {stockActual}
            </div>
          </div>

          <div className="mb-5 grid grid-cols-2 rounded-xl bg-azul-oscuro/60 p-1">
            <button
              type="button"
              onClick={() => setModo('reposicion')}
              className={`rounded-lg px-3 py-2.5 text-sm font-bold transition ${
                modo === 'reposicion'
                  ? 'bg-amarillo-dorado text-azul-oscuro shadow'
                  : 'text-blanco-puro/70 hover:text-blanco-puro'
              }`}
            >
              Reposición
            </button>

            <button
              type="button"
              onClick={() => setModo('ajuste')}
              className={`rounded-lg px-3 py-2.5 text-sm font-bold transition ${
                modo === 'ajuste'
                  ? 'bg-amarillo-dorado text-azul-oscuro shadow'
                  : 'text-blanco-puro/70 hover:text-blanco-puro'
              }`}
            >
              Ajuste
            </button>
          </div>

          {modo === 'reposicion' ? (
            <label className="block">
              <span className="mb-1 block text-xs font-bold text-amarillo-dorado">
                Cantidad que ingresa
              </span>

              <input
                autoFocus
                type="number"
                min="0.001"
                step="0.001"
                value={cantidad}
                onChange={(e) => setCantidad(e.target.value)}
                className={inputClass}
                required
              />
            </label>
          ) : (
            <label className="block">
              <span className="mb-1 block text-xs font-bold text-amarillo-dorado">
                Stock real contado
              </span>

              <input
                autoFocus
                type="number"
                min="0"
                step="0.001"
                value={nuevoStock}
                onChange={(e) => setNuevoStock(e.target.value)}
                className={inputClass}
                required
              />
            </label>
          )}

          <label className="mt-4 block">
            <span className="mb-1 block text-xs font-bold text-blanco-puro/70">
              Motivo
            </span>

            <input
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
              placeholder={
                modo === 'reposicion'
                  ? 'Ej. Compra a proveedor'
                  : 'Ej. Conteo físico'
              }
              className={inputClass}
            />
          </label>

          {error && (
            <div className="mt-4 rounded-xl border border-red-300/30 bg-red-500/20 px-3 py-2 text-sm text-red-100">
              {error}
            </div>
          )}

          <div className="mt-6 flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={guardando}
              className="rounded-xl border border-blanco-puro/30 bg-blanco-puro/5 px-4 py-2 text-sm font-semibold text-blanco-puro transition hover:bg-blanco-puro/10 disabled:opacity-50"
            >
              Cancelar
            </button>

            <button
              type="submit"
              disabled={guardando}
              className="rounded-xl bg-amarillo-dorado px-5 py-2 text-sm font-bold text-azul-oscuro shadow-lg transition hover:bg-amber-400 disabled:opacity-50"
            >
              {guardando
                ? 'Guardando...'
                : modo === 'reposicion'
                  ? 'Registrar reposición'
                  : 'Guardar ajuste'}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
